export default "{\n    \"poweredByResq\": \"Desarrollado por ResQ\"\n}\n"